namespace appn.views.billing.confirmInvoice {

    class InitArgs {
        hasValidCardLoaded: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();
    }

    function addEvents() {
        $('.btn-success').click(function(e) {
            e.preventDefault();

            $(this).prop('disabled', true);

            $('.loadingScreen .loading-headertext').text(_initArgs.hasValidCardLoaded);
            $('.loadingScreen .loading-subtitletext').text('Please do not refresh or close this page');
            appn.dialog.showLoading();

            $('form#appnForm').submit();
        });
    }
}

